import { cva } from "class-variance-authority";

export const sidebarStyles = cva(
  "w-[300px] bg-white border-r border-[#EAECF0] sticky top-0 flex flex-col h-screen py-4"
);

export const getUsersInitials = (name: string) => {
  const initials = name
    .split(" ")
    .map((word) => word[0])
    .join("");
  return initials.slice(0, 1).toUpperCase();
};
